export default __webpack_public_path__ + "static/media/continue.58112380.svg";